import { render, staticRenderFns } from "./ChatAttachment.vue?vue&type=template&id=7f84e220&"
import script from "./ChatAttachment.vue?vue&type=script&lang=js&"
export * from "./ChatAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports